module.exports = __webpack_public_path__ + "static/media/IC204preamg.0f68467c.jpg";